import { useAddCourse } from '@actions';
import Button from '@components/V4/Button';
import Modal from '@components/V4/Modal/Modal';
import { LmsCatalogCourseDTO } from '@shared/apis/courses.apis';
import useToast from 'apps/agora/src/hooks/useToast';
import { useEffect, useState } from 'react';
import CourseForm, { CourseFormValues, EMPTY_COURSE_FORM } from './CourseForm';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onCreated: (courseId: string) => void;
  lmsCatalog: LmsCatalogCourseDTO[];
  isLmsCatalogLoading?: boolean;
  prefill?: Partial<CourseFormValues>;
};

const CourseCreateModal = (props: Props) => {
  const { isOpen, onClose, onCreated, lmsCatalog, isLmsCatalogLoading, prefill } = props;
  const toast = useToast();
  const [values, setValues] = useState<CourseFormValues>({ ...EMPTY_COURSE_FORM, ...prefill });

  useEffect(() => {
    if (isOpen) setValues({ ...EMPTY_COURSE_FORM, ...prefill });
  }, [isOpen, prefill]);

  const { mutate: addCourse, isLoading } = useAddCourse({
    onSuccess: (response) => {
      toast.success('Course created.');
      onCreated(response.id);
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.error?.message ?? 'The course could not be created.');
    },
  });

  const submit = () => {
    if (!values.title.trim()) {
      toast.error('A title is required.');
      return;
    }
    addCourse({
      title: values.title.trim(),
      subtitle: values.subtitle.trim(),
      abbreviation: values.abbreviation.trim(),
      lmsCourseId: values.lmsCourseId,
      lmsCoursePrice: values.lmsCoursePrice,
      isFree: values.isFree,
      isMentorless: values.isMentorless,
      country: values.country,
      color: values.color,
    });
  };

  return (
    <Modal size="large" isOpen={isOpen} onClose={onClose}>
      <Modal.Header title="New course" />
      <Modal.Body>
        <CourseForm
          mode="create"
          value={values}
          onChange={(patch) => setValues((current) => ({ ...current, ...patch }))}
          lmsCatalog={lmsCatalog}
          isLmsCatalogLoading={isLmsCatalogLoading}
        />
      </Modal.Body>
      <Modal.Footer className="mt-4">
        <div className="flex justify-end gap-3">
          <Button variant="secondary" buttonText="Cancel" onClick={onClose} />
          <Button buttonText="Create course" onClick={submit} isLoading={isLoading} />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CourseCreateModal;
